import { Component, signal } from '@angular/core';
import { Header } from './components/header/header';
import { RouterOutlet } from '@angular/router';
import { Footer } from './components/footer/footer';
import { MobileMenu } from './components/mobile-menu/mobile-menu';
import { MenuService } from './services/menu.service';

@Component({
  selector: 'smm-layout',
  imports: [Header, RouterOutlet, Footer, MobileMenu],
  templateUrl: './layout.html',
  styleUrl: './layout.scss',
  providers: [MenuService],
})
export class Layout {}
